import { JoinPayload } from '~/common/types/types';

const joinPayload: JoinPayload = {
  title: 'technology.qa.join.title',
  description: 'join.description',
  postscript: 'join.postscript',
  registrationBtn: 'registration.apply',
};

export { joinPayload };
